import { Component, OnInit } from '@angular/core';
import { Router, RouterModule, NavigationEnd } from '@angular/router';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatIconRegistry } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { CommonModule } from '@angular/common';
import { AppConfigService } from './services/app-config.service';
import { filter } from 'rxjs/operators';
import { SwUpdate } from '@angular/service-worker';
import { interval } from 'rxjs';
import { DialogContainerDirective } from '@progress/kendo-angular-dialog';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterModule,
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatCardModule,
    MatDividerModule,
    DialogContainerDirective
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Bell Supply Mobile';

  background = 'inherit';
  navBarBackground = '#0066bf';
  navBarText = 'white';
  isHomePage = false;

  constructor(
    private router: Router,
    private appConfigService: AppConfigService,
    private swUpdate: SwUpdate,
    private iconRegistry: MatIconRegistry
  ) {
    // Use Material Symbols Outlined across the app
    this.iconRegistry.setDefaultFontSetClass('material-symbols-outlined');
  }

  ngOnInit() {
    // Track route changes to show/hide toolbar
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isHomePage = event.url === '/' || event.url === '/home';
    });

    // Check initial route
    this.isHomePage = this.router.url === '/' || this.router.url === '/home';

    // Service Worker Update Logic
    this.initializeServiceWorkerUpdates();
  }

  private initializeServiceWorkerUpdates() {
    if (this.swUpdate.isEnabled) {
      // Check for updates immediately when app starts
      this.checkForUpdate();

      // Check for updates every 30 seconds
      interval(30000).subscribe(() => {
        this.checkForUpdate();
      });

      // Listen for available updates and apply them immediately
      this.swUpdate.versionUpdates.pipe(
        filter(evt => evt.type === 'VERSION_READY')
      ).subscribe(() => {
        console.log('New version available, updating...');
        this.swUpdate.activateUpdate().then(() => {
          console.log('App updated, reloading...');
          window.location.reload();
        });
      });
    }
  }

  private checkForUpdate() {
    this.swUpdate.checkForUpdate().then((hasUpdate) => {
      if (hasUpdate) {
        console.log('Update available, will activate when ready');
      }
    }).catch((error) => {
      console.error('Error checking for updates:', error);
    });
  }
}
